import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FbNotificationsDashboardCardService } from './fb-notifications-dashboard-card.service';
import { take } from 'rxjs/operators';
import * as FB from './../../form-designer/fb-state/actions/fb.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'app-models';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomButtonActionService } from 'custom-button-action';
import * as moment from 'moment';
import 'moment-timezone';

@Component({
  selector: 'app-fb-notifications-dashboard-card',
  templateUrl: './fb-notifications-dashboard-card.component.html',
  styleUrls: ['./fb-notifications-dashboard-card.component.scss']
})
export class FbNotificationsDashboardCardComponent implements OnChanges {
  @Input() content: {
    type: string,
    title: string,
    noOfRows: number,
    notificationRedirection?: any,
    cardHeight?: number
  };
  notificationList = [];

  constructor(
    private fbNotificationsDashboardCardService: FbNotificationsDashboardCardService,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    private customButtonActionService: CustomButtonActionService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content) {
      this.fetchNotifications();
    }
  }

  fetchNotifications() {
    if (!this.content) {
      return;
    }
    this.fbNotificationsDashboardCardService.fetchNotifications()
      .pipe(take(1))
      .subscribe((notificationsList: any[]) => {
        this.notificationList = this.mapNotifications(notificationsList);
      });
  }

  private mapNotifications(notificationsList: any[]): any[] {
    return notificationsList.filter(notification => !notification.actioned).map(x => {
      const date = this.formatDate(x.employeeDetails);
      const text = this.formatDateinText(x);
      return {
        ...x,
        text,
        employeeDetails: {
          ...x.employeeDetails,
          date
        }
      };
    });
  }

  private formatDateinText(notification: any) {
    if (notification?.text && notification.employeeDetails?.dashboardNotificationType && ['TA Requisition', 'Applicant Reminder', 'TANewApplicant', 'TA Interview Reminder', 'TA Postposition'].includes(notification.employeeDetails.dashboardNotificationType)) {
      // const dateMatch = notification.text.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?/);
      const dateMatch = notification.text.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?|(\d{2} \w{3} \d{4} \d{2}:\d{2} [APM]{2})/);
      if (!dateMatch) {
        return notification.text || null;
      }
      const extractedDate = dateMatch[0];
      let localDate;
      if (/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?/.test(extractedDate)) {
        localDate = moment.utc(extractedDate, 'YYYY-MM-DD HH:mm:ss.SSSSSS').local().format('MM/DD/YYYY hh:mm A');
      } else {
        localDate = moment.utc(extractedDate, 'DD MMM YYYY hh:mm A').local().format('MM/DD/YYYY hh:mm A');
      }
      return notification.text.replace(extractedDate, localDate);;
    }
    return notification.text || null;
  }

  private formatDate(employeeDetails: any): string | null {
    if (employeeDetails && employeeDetails.date) {
      if (employeeDetails.dashboardNotificationType === 'ProjectTimesheet' && employeeDetails.toDate) {
        const fromDate = moment(employeeDetails.date, 'MM/DD/YYYY hh:mm A').format('MM/DD/YYYY');
        const toDate = moment(employeeDetails.toDate, 'MM/DD/YYYY hh:mm A').format('MM/DD/YYYY');
        return `Weekly Duration:${fromDate} to ${toDate}`;
      }
      if (['TA Requisition', 'Applicant Reminder', 'TANewApplicant', 'TA Interview Reminder', 'TA Postposition'].includes(employeeDetails.dashboardNotificationType)) {
        return null;
      }
      return employeeDetails.date;
    }
    return null;
  }


  onViewDetails(notification: any) {
    switch (notification.employeeDetails.dashboardNotificationType) {
      case 'Leave Management':
      case 'Exit':
      case 'Attendance':
      case 'Leave Management RM APPR':
      case 'Leave Management HR APPR':
      case 'Leave Management RM Reject':
      case 'ProjectTimesheet':
      case 'TA Requisition':
      case 'Applicant Reminder':
      case 'TANewApplicant':
      case 'TA Interview Reminder':
      case 'TA Postposition':
        if (this.content?.notificationRedirection && this.content.notificationRedirection[notification.employeeDetails.dashboardNotificationType]) {
          const DASHBOARD_NOTIFICATION_TYPES = {
            TA_REQUISITION: 'TA Requisition',
            TA_INTERVIEW_REMINDER: 'TA Interview Reminder',
            TA_NEW_APPLICANT: 'TANewApplicant',
            TA_POSTPOSITION: 'TA Postposition'
          };

          const setDashboardNotificationType = (type) => {
            this.setOrRemoveSessionStorageItem('dashboardNotificationType', type);
          };

          const { dashboardNotificationType, fbpageformId } = notification.employeeDetails;

          switch (dashboardNotificationType) {
            case DASHBOARD_NOTIFICATION_TYPES.TA_REQUISITION:
              setDashboardNotificationType(DASHBOARD_NOTIFICATION_TYPES.TA_REQUISITION);
              this.setOrRemoveSessionStorageItem('createRequistionPageFormID', fbpageformId);
              break;
            case DASHBOARD_NOTIFICATION_TYPES.TA_POSTPOSITION:
              this.setOrRemoveSessionStorageItem('prevRedirectPageFormId', sessionStorage.getItem('pageFormId'));
              setDashboardNotificationType(dashboardNotificationType);
              break;
            case DASHBOARD_NOTIFICATION_TYPES.TA_INTERVIEW_REMINDER:
            case DASHBOARD_NOTIFICATION_TYPES.TA_NEW_APPLICANT:
              setDashboardNotificationType(dashboardNotificationType);
              break;
          }
          this.setOrRemoveSessionStorageItem('currentPageFormId', sessionStorage.getItem('pageFormId'));
          this.setOrRemoveSessionStorageItem('formDataId', notification.employeeDetails.formDataId);
          const redirectPageFormId = this.content.notificationRedirection[dashboardNotificationType];
          let selectedPageId, selectedTabIndex;
          if (typeof redirectPageFormId === 'object') {
            selectedPageId = redirectPageFormId.selectedPage;
            selectedTabIndex = redirectPageFormId.selectedTabIndex;
          } else {
            selectedPageId = redirectPageFormId;
          }
          this.setOrRemoveSessionStorageItem('redirectId', selectedPageId);
          this.setOrRemoveSessionStorageItem('redirectPageFormId', selectedPageId);
          if (selectedPageId) {
            this.customButtonActionService.getPageFormById(selectedPageId)
              .pipe(take(1)).subscribe((response: any) => {
                if (response) {
                  const item = {
                    formType: response.buildFormatTypeId,
                    pageFormId: response.id,
                    setFormDataId: true
                  };
                  this.setOrRemoveSessionStorageItem('interviewProcessSetupId', notification.employeeDetails.interviewProcessSetupId);
                  this.setOrRemoveSessionStorageItem('FbEmployeeId', notification.employeeDetails.beneficiaryId);
                  this.setOrRemoveSessionStorageItem('FbActualEmployeeId', notification.employeeDetails.employeeId);
                  this.setOrRemoveSessionStorageItem('AttendanceDataId', notification.id);
                  this.setOrRemoveSessionStorageItem('idToGetDetails', ['TA Interview Reminder', 'TA Postposition'].includes(dashboardNotificationType) ? notification.employeeDetails.jobPostPositionId : notification.id);
                  this.setOrRemoveSessionStorageItem('applicantId', notification.employeeDetails.applicantId);
                  this.setOrRemoveSessionStorageItem('applicantInfoId', dashboardNotificationType === 'TANewApplicant' ? notification.employeeDetails.applicantClientJobPositionsId : notification.id);
                  this.setOrRemoveSessionStorageItem('redirectTabIndex', selectedTabIndex);
                  this.setOrRemoveSessionStorageItem('fbFormDataDTO', JSON.stringify([notification.employeeDetails.masterListRowDTO]))
                  this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                }
              });
          }
        }
        break;
      case 'Onboarding':
        sessionStorage.setItem('FbEmployeeId', notification.employeeDetails.beneficiaryId);
        this.store.dispatch(new FB.SetIsBeneficiaryProfile(true));
        setTimeout(() => {
          this.router.navigate(['../employee/profile'], {
            queryParams: {
              pageFrom: 'FB',
              fbEmpId: notification.id
            },
            relativeTo: this.route
          });
        }, 0);
        break;
    }
  }

  private setOrRemoveSessionStorageItem(key: string, value: any) {
    if (value !== null && value !== undefined) {
      sessionStorage.setItem(key, value);
    } else if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }

}
